import { mdiContentCopy } from '@mdi/js';
import Command from './_Command';
import { ApryseSDK } from '../../pdf/ApryseSDK';

export default class CopyController extends Command {
    constructor() {
        super({
            Key: 'copyAnnotation',
            Enabled: ApryseSDK.canCopy,
            Path: mdiContentCopy,
            Callback: ApryseSDK.commonCopy,
        });
    }
}
